"use strict";
/**
 * Ось C — роли ЧЛЕНСТВА в магазине (RBAC-1.3, RBAC-2.1 AD-2.1-6).
 *
 * Это НЕ роли из таблицы `roles`: ось A — тир доверия, ось B — платформенная должность.
 * Членство отвечает на вопрос «в чьих данных этот человек имеет право работать», и на
 * него не отвечает ни одна глобальная роль (RBAC-1 AD-1).
 *
 * Живут в `merchant_members.role`, где набор закреплён `CHECK`. Совпадение словаря с этим
 * `CHECK` утверждается тестом — до RBAC-2.1 их не связывало ничто.
 *
 * ⚠ Модуль знает ТОЛЬКО ось C. Ни платформенного админа, ни имён глобальных ролей и прав
 * здесь нет и не будет: обход админа — явная ветка в каждом сервисе (AD-2.1-2), а ось B
 * внутри словаря оси C была бы тем самым смешением, ради устранения которого написан эпик.
 * Оси A и B живут рядом, в `../roles` (RBAC-1.9) — соседним модулем, а не этим.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVITABLE_ROLES = exports.MERCHANT_MEMBER_ROLE_VALUES = exports.MERCHANT_MEMBER_ROLES = void 0;
exports.MERCHANT_MEMBER_ROLES = {
    OWNER: 'owner',
    MANAGER: 'manager',
    STAFF: 'staff',
};
/** Tuple form — feeds `z.enum(...)` and `@IsEnum(...)`. */
exports.MERCHANT_MEMBER_ROLE_VALUES = Object.values(exports.MERCHANT_MEMBER_ROLES);
/**
 * Роли, на которые можно позвать и назначить (RBAC-1.6).
 *
 * `owner` не входит: владелец у магазина один, и меняется он передачей магазина, которой
 * в эпике нет.
 */
exports.INVITABLE_ROLES = [
    exports.MERCHANT_MEMBER_ROLES.MANAGER,
    exports.MERCHANT_MEMBER_ROLES.STAFF,
];
